var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 15L22.6667 20V16.25H10.6667V13.75H22.6667V10L29.3334 15Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6653 3.74882C16.2419 3.74472 17.8038 4.03396 19.2603 4.59978C20.7169 5.16559 22.0392 5.99674 23.1506 7.04507L21.2653 8.81257C19.5026 7.16007 17.1586 6.24882 14.6653 6.24882C12.172 6.24882 9.82797 7.16007 8.0653 8.81257C6.30263 10.4651 5.33063 12.6626 5.33063 15.0001C5.33063 17.3376 6.30263 19.5351 8.0653 21.1876C9.82797 22.8401 12.172 23.7513 14.6653 23.7513C17.1586 23.7513 19.5026 22.8401 21.2653 21.1876L23.1506 22.9551C20.8853 25.0801 17.872 26.2513 14.6653 26.2513C11.4586 26.2513 8.4453 25.0801 6.17997 22.9551C3.9133 20.8313 2.66397 18.0063 2.66397 15.0001C2.66397 11.9938 3.9133 9.16882 6.17997 7.04507C7.29144 5.99674 8.61375 5.16559 10.0703 4.59978C11.5268 4.03396 13.0887 3.74472 14.6653 3.74882Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/Log out icon.0e464392732e54cd38e6e275c048c3df.svg";
export { ForwardRef as ReactComponent };